// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1_vmh","cls2":"PingAnswerStyles-cls2_Chj PingAnswerStyles-cls1_vmh"};